import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 21h6","key":"svg-0"}],["path",{"d":"M9 21v-18l-6 6h18","key":"svg-1"}],["path",{"d":"M9 3l10 6","key":"svg-2"}],["path",{"d":"M17 9v4a2 2 0 1 1 -2 2","key":"svg-3"}]]

/**
 * IconCrane
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3JhbmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgMjFoNiIgLz4KICA8cGF0aCBkPSJNOSAyMXYtMThsLTYgNmgxOCIgLz4KICA8cGF0aCBkPSJNOSAzbDEwIDYiIC8+CiAgPHBhdGggZD0iTTE3IDl2NGEyIDIgMCAxIDEgLTIgMiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/crane
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCrane = createReactComponent('outline', 'crane', 'Crane', __iconNode);

export default IconCrane;